import request from "../utils/request";


export function upload(files) {
    let formData = new FormData()
    files.forEach(item => formData.append('files', item))
    return request({
        url: '/api/order/mould/upload',
        method: 'post',
        data: formData
    })
}

export function deleteOrderMould(mouldNo) {
    return request({
        url: '/api/order/mould/delete',
        method: 'delete',
        params: {mould_no: mouldNo}
    })
}

export function updateOrderMouldLocation(mouldLocation) {
    return request({
        url: '/api/order/mould/location',
        method: 'post',
        data: mouldLocation
    })
}